import { cn } from '../../lib/cn';

export function Label({ className, children, htmlFor, required, ...props }) {
  return (
    <label
      htmlFor={htmlFor}
      className={cn(
        'text-[11px] font-medium uppercase tracking-[0.12em]',
        className
      )}
      style={{ color: 'var(--dash-text-soft)' }}
      {...props}
    >
      {children}
      {required && (
        <span
          className="ml-1"
          style={{ color: 'var(--dash-primary)' }}
        >
          *
        </span>
      )}
    </label>
  );
}
